import { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import Account from "./Account"
import Wallet from "./Wallet"
import Activity from "./Activity"
import VipLevels from "./VipLevel"
import Referral from "./Referral"
import AccountSecurity from "./AccountSecurity"
import ShareCredits from "./ShareCredits"
import { handleLogout } from "../snippets/Logout"
import { useGlobalContext } from "../data/GlobalContext"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlus } from "@fortawesome/free-solid-svg-icons"
import Deposit from "../transactions/Deposit"
import UserManual from "../UserManual"
import DarkTheme from "../data/DarkTheme"
import Contact from "../Contact"
export const currentPath = window.location.pathname
export const currentDomain = window.location.origin

export default function Profile() {
  const {
    vipDetails,
    username,
    playerDetails,
    handleReturnWallet,
    sg8Wallet,
    loading,
  } = useGlobalContext()
  const [activePopup, setActivePopup] = useState(null)
  const [isUserManual, setUserManual] = useState(false)
  // On desktop, default to "accounts"; on mobile, default to empty.
  const [activeSection, setActiveSection] = useState(() =>
    window.innerWidth > 840 ? "accounts" : ""
  )
  const [selectedContact, setSelectedContact] = useState(null)
  // const [showBonus, setShowBonus] = useState(false)
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 840)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 840)
    }
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  // Open functions
  const handleOpenPopup = (type) => {
    setActivePopup(type)
  }

  // Close functions
  const handleClosePopup = () => {
    setActivePopup(null)
  }

  useEffect(() => {
    // Disable body scroll when a popup is open.
    document.body.style.overflow = activePopup ? "hidden" : "auto"
    return () => {
      document.body.style.overflow = "auto"
    }
  }, [activePopup])

  const onLogout = () => {
    handleLogout(username)
  }

  const navigationProfile = [
    { id: 1, label: "Information", section: "accounts" },
    { id: 2, label: "Wallet", section: "wallet" },
    { id: 3, label: "Activity", section: "activity" },
    { id: 4, label: "VIP Level", section: "vip" },
    { id: 5, label: "Referral Status", section: "referral" },
    { id: 6, label: "Share Credits", section: "credits" },
    { id: 7, label: "Account Security", section: "security" },
    {
      id: 8,
      label: "Logout",
      section: onLogout,
      className: "profile-logout",
    },
  ]

  // Update activeSection based on URL hash or search param on initial mount.
  useEffect(() => {
    const hash = window.location.hash ? window.location.hash.slice(1) : null
    const params = new URLSearchParams(window.location.search)
    const searchParam = params.get("section") || params.get("")
    const section = hash || searchParam
    if (section && navigationProfile.find((nav) => nav.section === section)) {
      setActiveSection(section)
    }
  }, [])

  // Optional: Listen for hash changes after initial load.
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash ? window.location.hash.slice(1) : null
      if (hash && navigationProfile.find((nav) => nav.section === hash)) {
        setActiveSection(hash)
      }
    }

    window.addEventListener("hashchange", handleHashChange)
    return () => {
      window.removeEventListener("hashchange", handleHashChange)
    }
  }, [])

  // Display status based on playerDetails.
  const statusText = playerDetails?.status
  const isVerified = statusText && statusText.toLowerCase() === "verified"

  let statusDisplay
  if (!statusText) {
    statusDisplay = (
      <div className="fgh-profile-card-info-status preparing">
        Preparing ....
      </div>
    )
  } else if (isVerified) {
    statusDisplay = (
      <div className="fgh-profile-card-info-status verified">
        <img src="/images/icon/check-icon.webp" alt="Verified" />
        {statusText}
      </div>
    )
  } else {
    statusDisplay = (
      <div className="fgh-profile-card-info-status not-verified">
        <img src="/images/icon/notice-red.webp" alt="Not Verified" />
        {statusText}
      </div>
    )
  }
  const showUserManual = () => {
    setUserManual(true)
  }

  // useEffect(() => {
  //   const updateCountdown = () => {
  //     const now = new Date()

  //     // Define today's 8PM and 9PM
  //     const today8PM = new Date()
  //     today8PM.setHours(20, 0, 0, 0) // 8:00:00 PM

  //     const today12PM = new Date()
  //     today12PM.setHours(24, 0, 0, 0) // 12:00:00 MN

  //     // Check if current time is between 8PM and 9PM
  //     if (now >= today8PM && now < today12PM) {
  //       setShowBonus(true)
  //     } else {
  //       setShowBonus(false)
  //     }
  //   }

  //   // Run immediately and every minute
  //   updateCountdown()
  //   const interval = setInterval(updateCountdown, 60 * 1000)

  //   return () => clearInterval(interval)
  // }, [])
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Profile - FGH - Your One-Stop Gaming Site</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta
          name="description"
          content="Join FGH VIP Club for exclusive bonuses, referral rewards & elite perks. Fast payouts, local wallet support (GCash/Maya), Filipino casino loyalty for players 21+."
        />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="main-profile-container all-page-main-container-min-height main-container-global-adjusted-padding">
        <div className="profile-navigation">
          <div className="fgh-profile-card">
            <div className="fgh-profile-content">
              <img
                src={vipDetails?.vipImage}
                alt=""
                className="profile-vip-icon"
              />
              <div className="fgh-profile-card-info">
                <div className="fgh-profile-card-info-welcome">Welcome!</div>
                <div className="fgh-profile-card-info-id">{username}</div>
                {statusDisplay}
              </div>
            </div>
            <div className="fgh-profile-dark-theme">
              <DarkTheme />
            </div>
          </div>
          <div className="fgh-profile-nav-divider"></div>
          <div className="profile-mobile-balance">
            <div className="fgh-snow-melt">
              <img src="/images/icon/SNOW-MELTING.webp" alt="" />
            </div>
            <div>
              <label>Available Balance</label>
              <span> {loading ? "Preparing..." : sg8Wallet}</span>
              <p
                style={{
                  fontSize: "12px",
                  fontWeight: "500",
                  color: "#fff",
                }}
              >
                <a
                  onClick={(e) => {
                    e.preventDefault()
                    handleReturnWallet(username)
                  }}
                  style={{
                    color: "#fff",
                    display: "flex",
                  }}
                >
                  <img
                    style={{
                      width: "12px",
                      height: "12px",
                      marginRight: "3px",
                    }}
                    src="/images/icon/FGH-RETURN-ICON.webp"
                    alt=""
                  />
                  Return Wallet
                </a>
              </p>
            </div>
            <button
              className="fgh-mobile-deposit-btn"
              onClick={() => handleOpenPopup("deposit")}
            >
              <FontAwesomeIcon icon={faPlus} className="fa-deposit-icon" /> Cash
              In
            </button>
          </div>
          <ul className="fgh-profile-nav-items">
            {!isUserManual && (
              <button className="profile-user-manual" onClick={showUserManual}>
                User Guide
              </button>
            )}
            {navigationProfile.reduce((acc, nav) => {
              const isActive = activeSection === nav.section ? "active" : ""

              // Create the <li>
              let navItem
              if (nav.label === "Logout") {
                navItem = (
                  <li
                    key={nav.id}
                    className={`${nav.className}`}
                    onClick={onLogout}
                  >
                    <a>{nav.label}</a>
                  </li>
                )
              } else {
                navItem = (
                  <li
                    key={nav.id}
                    className={`profile-tab ${isActive}`}
                    onClick={() => {
                      window.location.hash = nav.section
                      setActiveSection(nav.section)
                    }}
                  >
                    <a>{nav.label}</a>
                  </li>
                )
              }

              acc.push(navItem)

              // After Account Security, add ContactUs ONLY on mobile
              if (nav.label === "Account Security" && isMobile) {
                acc.push(
                  <li
                    key="contact-us"
                    style={{ background: "none", marginTop: "-24px" }}
                  >
                    <Contact setSelectedContact={setSelectedContact} />
                  </li>
                )
              }

              return acc
            }, [])}
          </ul>
        </div>
        {activePopup === "deposit" && (
          <div>
            <Deposit onClose={handleClosePopup} />
          </div>
        )}
        {activeSection === "accounts" && (
          <Account onClose={() => setActiveSection("")} />
        )}
        {activeSection === "wallet" && (
          <Wallet onClose={() => setActiveSection("")} />
        )}
        {activeSection === "activity" && (
          <Activity onClose={() => setActiveSection("")} />
        )}
        {activeSection === "vip" && (
          <VipLevels onClose={() => setActiveSection("")} />
        )}
        {activeSection === "referral" && (
          <Referral onClose={() => setActiveSection("")} />
        )}
        {activeSection === "security" && (
          <AccountSecurity onClose={() => setActiveSection("")} />
        )}
        {activeSection === "credits" && (
          <ShareCredits onClose={() => setActiveSection("")} />
        )}

        {isUserManual && (
          <>
            <UserManual closeUserManual={() => setUserManual(false)} />
          </>
        )}
      </div>
    </>
  )
}
